import { type Classification } from "@/src/models/constants/classifications";

export interface AutoIntakeRule {
  classification: Classification;
  /** Rate from 0 to 1. 1.0 = always auto-intake, 0.9 = 90% auto-intake / 10% holdout */
  autoIntakeRate: number;
}

/** Default auto-intake rate. 90% auto-intake / 10% holdout for comparison. */
const DEFAULT_AUTO_INTAKE_RATE = 0.9;

export const autoIntakeRule = (
  classification: Classification,
  autoIntakeRate: number = DEFAULT_AUTO_INTAKE_RATE
): AutoIntakeRule => ({
  classification,
  autoIntakeRate,
});
